import script from "./Background-wap.vue?vue&type=script&lang=ts&setup=true"
export * from "./Background-wap.vue?vue&type=script&lang=ts&setup=true"

import "./Background-wap.vue?vue&type=style&index=0&id=148934f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-148934f8"]])

export default __exports__